import zhLocale from './zh_cn'
import tcLocale from './zh_tc'
import enLocale from './en_us'
import { getI18nLangFromLandingStorage } from '@repo/common-utils/utils/landingI18nLang'

import initI18n from '../tools'

export default initI18n({
  zhLocale,
  tcLocale,
  enLocale,
  defaultLang: 'zhTc',
  getLang: getI18nLangFromLandingStorage,
})
